/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ViewComponentKey } from './key/view-component.key';
import { ComponentProvider } from './provider/component.provider';
import { TextComponent } from './component/text/text.component';
import { LabelComponent } from './component/label/label.component';
import { SvgComponent } from './component/svg/svg.component';
import { ImageComponent } from './component/image/image.component';
import { ButtonComponent } from './component/button/button.component';
import { LinkComponent } from './component/link/link.component';
import { ValueComponent } from './component/value/value.component';
import { TextInputComponent } from './component/text-input/text-input.component';
import { TextAreaComponent } from './component/text-area/text-area.component';
import { SelectInputComponent } from './component/select-input/select-input.component';
import { ValueLabelComponent } from './component/value-label/value-label.component';
import { ValueErrorComponent } from './component/value-error/value-error.component';
import { ContentComponent } from './component/content/content.component';
import { ContainerComponent } from './component/container/container.component';
import { FormFieldComponent } from './component/form-field/form-field.component';
import { TableComponent } from './component/table/table.component';
import { BackdropComponent } from './component/backdrop/backdrop.component';
import { LoadIndicatorComponent } from './component/load-indicator/load-indicator.component';
import { TemplateComponent } from './component/template/template.component';
import { CheckboxComponent } from './component/checkbox/checkbox.component';
import { TabsComponent } from './component/tabs/tabs.component';

export class ViewInitializer {

  static initialize() {
    ViewInitializer.registerComponents();
  }

  static registerComponents() {
    ComponentProvider.registerComponentType(ViewComponentKey.TEXT, TextComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.LABEL, LabelComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.IMAGE, ImageComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.SVG_SYMBOL, SvgComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.SVG_CODE, SvgComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.ACTION, ButtonComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.BUTTON, ButtonComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.LINK, LinkComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.CONTENT, ContentComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.CONTAINER, ContainerComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.VALUE, ValueComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.TEXT_INPUT, TextInputComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.TEXT_AREA, TextAreaComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.SELECT_INPUT, SelectInputComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.VALUE_LABEL, ValueLabelComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.VALUE_ERROR, ValueErrorComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.FORM_FIELD, FormFieldComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.TABLE, TableComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.BACKDROP, BackdropComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.LOAD_INDICATOR, LoadIndicatorComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.TEMPLATE, TemplateComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.CHECKBOX, CheckboxComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.TABS, TabsComponent);
  }

}
